import { ErrorMessage, Field, Form, Formik } from "formik";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { SpinnerCircleMini } from "../atoms/spinner/Spinner";
import Footer from "../molecules/footer/Footer";
import Header from "../molecules/header/Header";
import { login, loginSSO } from "../services/LoginService";
import useSSO from "./../../hooks/useSSO";

const LoginBienvenida = () => {
  const navigate = useNavigate();
  const [sso] = useSSO();

  const [values] = useState({
    username: "",
    password: "",
  });

  const [error, setError] = useState("");
  const [loginCorrecto, setLoginCorrecto] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleShowPasswordClick = () => {
    setShowPassword(!showPassword);
  };

  
  
  
  const credB = localStorage.getItem('credbloqueado')
  useEffect(() => {
    localStorage.clear();
    localStorage.setItem("credbloqueado", JSON.stringify(credB))

    if (sso && sso !== "No tiene") {
      
      loginSSO(sso)
        .then((data) => {
          localStorage.setItem("token", sso);
          
          if (data === "NO AUTORIZADO") {
            setError("Error en las credenciales");
            localStorage.removeItem("token");
          } else {
            navigate("/home");
          }
        })
        .catch(() => {
          setError("Error en la conexión con SSO");
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sso,credB]);

  return (
    <>
      {/* Si se añaden distintos dominios se podria obtener a través para idnicar donde se desea mostrar y donde no con : 
      window.location.hostname; */}
      {loginPersonal(
        values,
        setLoginCorrecto,
        setError,
        navigate,
        error,
        loginCorrecto,
        showPassword,
        handleShowPasswordClick
      )}

      {/*process.env.REACT_APP_DOMINIO === window.location.hostname
        ? cargaPagina(error)
        : loginPersonal(
            values,
            setLoginCorrecto,
            setError,
            navigate,
            error,
            loginCorrecto,
            showPassword,
            handleShowPasswordClick
          )*/}
    </>
  );
};
export default LoginBienvenida;
/*
function cargaPagina(error) {
  return (
    <div className="sso-loading">
      {!error ? "ESTOY CARGANDO LA PAGINA SSO" : error}
    </div>
  );
}*/

function loginPersonal(
  values,
  setLoginCorrecto,
  setError,
  navigate,
  error,
  loginCorrecto,
  showPassword,
  handleShowPasswordClick
) {
  return (
    <div className="me-auto ms-auto d-flex flex-column vh-100">
      <Header login={true}></Header>
      <main className="my-auto">
        <div className="row text-center login-page">
          <div className="d-flex flex-column ">
            <div className="col-md-12 card card-login">
              <div className="row">
                <div className="col-md-12 login-form-header">
                  <h2 className="login-form-font-header">
                    <span>ACCESO A MI CARPETA</span>
                  </h2>
                </div>
              </div>
              <div className="row flex-column">
                <Formik
                  initialValues={{
                    username: values.username,
                    password: values.password,
                  }}
                  validate={(valores) => {
                    const errores = {};
                    if (valores.username == null || valores.username === "") {
                      errores.username = "Debe escribir un usuario.";
                    } else if (
                      valores.password == null ||
                      valores.password === ""
                    ) {
                      errores.password = "Debe escribir una contraseña.";
                    }
                    return errores;
                  }}
                  onSubmit={(valores) => {
                    setError("")
                    setLoginCorrecto(true);
                    
                    // valores.preventDefault();

                    // const credB = localStorage.getItem('credbloqueado')

                    localStorage.clear();
                    // useEffect(()=>{localStorage.setItem("credbloqueado", JSON.stringify(credB))},[credB])


                    login(valores).then((data) => {
                      
                      if (data.code === "ERR_NETWORK") {
                        setError("Error al conectar con el servidor.");
                      } else if (data === "NO AUTORIZADO" || !data?.nombre) {
                        setError("Error en las credenciales.");
                      } else {
                        navigate("/home");
                      }
                      setLoginCorrecto(false);
                    });
                  }}
                >
                  {({ errors }) => (
                    <>
                      <Form>
                        <div className="container">
                          <div className="row justify-content-center">
                            {/* {} */}
                            <div
                              className={`${error === " " ? "" : "p-2 text-danger"
                                }`}
                            >
                              {error}
                            </div>
                            <div className="row  col-xxl-12 col-xl-12 col-lg-12 cold-md-12 cold-sm-12 pb-2">
                              <label className="d-flex ms-2" htmlFor="username">
                                Usuario:
                              </label>
                              <div className="input-group">
                                <Field
                                  type="text"
                                  id="username"
                                  name="username"
                                  className="form-control"
                                  placeholder="Introduce un usuario"
                                />
                              </div>
                              <ErrorMessage
                                name="username"
                                component={() => (
                                  <div className="error rojo pt-2">
                                    {errors.username}
                                  </div>
                                )}
                              />
                            </div>

                            <div className="row col-xxl-12 col-xl-12 col-lg-12 cold-md-12 cold-sm-12">
                              <label className="d-flex ms-2" htmlFor="password">
                                Contraseña:
                              </label>
                              <div className="input-group">
                                <Field
                                  type={showPassword ? "text" : "password"}
                                  id="password"
                                  name="password"
                                  className="form-control"
                                  placeholder="Introduce una contraseña"
                                  aria-describedby="basic-addon2"
                                />
                                <div className="input-group-append">
                                  <span
                                    className={`input-group-text ${showPassword
                                        ? "fa-solid fa-eye"
                                        : "fa-solid fa-eye-slash"
                                      }`}
                                    aria-hidden="true"
                                    id="basic-addon2"
                                    onClick={handleShowPasswordClick}
                                  ></span>
                                </div>
                              </div>

                              <ErrorMessage
                                name="password"
                                component={() => (
                                  <div className="error rojo pt-2">
                                    {errors.password}
                                  </div>
                                )}
                              />
                            </div>

                            <div className="row justify-content-center pt-3">
                              <div className="col-md-12 py-3">
                                <button
                                  type="submit"
                                  className="btn"
                                  disabled={loginCorrecto}
                                >
                                  {loginCorrecto ? (
                                    <>
                                      <div className="d-flex justify-content-center">
                                        <SpinnerCircleMini
                                          clases={"background-border"}
                                        ></SpinnerCircleMini>
                                      </div>
                                    </>
                                  ) : (
                                    <>Acceder</>
                                  )}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Form>
                    </>
                  )}
                </Formik>
              </div>


            </div>

          </div>
        </div>
      </main>
      <Footer></Footer>
    </div>
  );
}
